import { graphql, useStaticQuery } from 'gatsby'

export const useNews = () => {
	const data = useStaticQuery(graphql`
		query {
			news: sanityNews {
				hero {
					headline
					_rawImage
					image {
						...Image
						alt
					}
				}
				press {
					_type
					articles {
						_key
						link
						quote
						source
						_rawLogo
					}
				}
				blogPosts {
					excerpt
					_rawContent
					date
					_id
					title
					slug {
						current
					}
					seo {
						description
					}
					_rawHero
					hero {
						...ImageWithPreview
						alt
					}
				}
        pressReleases {
          title
          _rawContent
          links {
            _key
            blank
            link
            title
          }
        }
				seo {
					title
					description
					image {
						asset {
							url
						}
					}
				}
			}
		}
	`)
	return data
}
